import React, { useState } from 'react';
import '../assets/css/Services.css';
// Import your service icons
import DedicatedVAIcon from '../assets/icons/va_icon.png';
import SpecializedStaffingIcon from '../assets/icons/staffing_icon.png';
import PerformanceMonitoringIcon from '../assets/icons/kpi_icon.png';
import BackupReplacementIcon from '../assets/icons/backups_icon.png';
import PayrollComplianceIcon from '../assets/icons/payroll_icon.png';

const Services = () => {
  const [flippedCards, setFlippedCards] = useState({});

  const services = [
    {
      title: "Dedicated Virtual Assistants",
      description: "Admin, Marketing, Sales Support, Customer Service",
      detailedDescription: "Experience the reliability of having a full-time virtual professional committed exclusively to your business. Our Dedicated Virtual Assistants are handpicked to match your specific industry needs, from real estate and e-commerce to admin and customer support. With ongoing supervision and performance tracking, you get consistent productivity and peace of mind, knowing your VA works as part of your own team.",
      icon: DedicatedVAIcon
    },
    {
      title: "Specialized Staffing",
      description: "E-commerce support, Real Estate VAs, Executive Assistants, Bookkeeping",
      detailedDescription: "Scale your operations effortlessly with our Specialized Staffing solutions. Whether you need trained professionals in marketing, bookkeeping, project coordination, or tech support, we provide tailored placements that align with your company's culture and objectives. We handle sourcing, vetting, onboarding, and HR support, so you can focus on growing your business while we build your dream team.",
      icon: SpecializedStaffingIcon
    },
    {
      title: "Performance Monitoring",
      description: "Time-tracking, KPIs, weekly reports",
      detailedDescription: "Stay in control of your remote team's productivity with our transparent performance management system. We monitor attendance, task completion, communication quality, and output metrics in real time. Our clients receive weekly reports and proactive insights to ensure accountability, continuous improvement, and measurable results across every role.",
      icon: PerformanceMonitoringIcon
    },
    {
      title: "Backup & Replacement",
      description: "7-day replacement guarantee for continuity",
      detailedDescription: "Your business should never stop, and we make sure it doesn't. In case of absence, performance issues, or unforeseen events, our Backup & Replacement service guarantees uninterrupted workflow. We maintain a ready pool of trained professionals who can step in seamlessly, ensuring operational continuity and zero downtime.",
      icon: BackupReplacementIcon
    },
    {
      title: "Payroll & Compliance",
      description: "Full management of payroll and compliance",
      detailedDescription: "We take care of your team's payroll, taxes, and government contributions so you don't have to. Our HR and finance experts ensure full compliance with Philippine labor laws and global client standards. You receive clear, consolidated billing while we manage local regulations, benefits, and accurate compensation for your virtual team.",
      icon: PayrollComplianceIcon
    }
  ];

  const handleLearnMore = (index) => {
    setFlippedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <section id="services" className="services">
      <h2>Our Services</h2>
      <p>Comprehensive virtual assistant solutions for your business needs</p>
      
      <div className="services-grid">
        {services.map((service, index) => (
          <div 
            key={index} 
            className={`service-card-container ${flippedCards[index] ? 'flipped' : ''}`}
          >
            <div className="service-card">
              <div className="service-card-front">
                <div className="service-icon">
                  <img src={service.icon} alt={service.title} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <button className="btn-outline" onClick={() => handleLearnMore(index)}>
                  Learn More
                </button>
              </div>
              <div className="service-card-back">
                <h3>{service.title}</h3>
                <p className="detailed-description">{service.detailedDescription}</p>
                <button className="btn-outline" onClick={() => handleLearnMore(index)}>
                  Back
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;